import React from 'react';
import Layout from '../components/layout.js';

const History = () => (
    <Layout>
        <div className="container main-content-wrap">
            <div className="columns is-centered"> 
                <div className="column is-four-fifths ">
                    <section className="content history-wrap">
                    <h3 className="title is-3 has-text-weight-light">Our History</h3>
                    <hr />
                    <p>
                        According to the local press, the first bowls match was played in Burgess Hill in 1895, and official records show the formation of the present club in 1902. The bowling green then was situated on the town lawns, located behind the Top House Public House, and made history in 1907 being the first club in Sussex to have floodlights
                    </p>

                    <p>
                        In 1917, the club paid the princely sum of £2 to move to a new home at Burgess Hill Lawn Tennis and Croquet Club on what is now the local shopping centre car park. The bowls club remained there for 12 years, when in 1929 it moved to its current location in Westhill Drive, off Royal George Road.
                    </p>        
                    <p>
                    In 1920 the current full-size rink was laid by the Chapman brothers whose family ran the Burgess Hill Steam Laundry. However, following the closure of the business in 1929 and the land was sold to the Urban District Council. An attractive pavilion was built in 1932 and subsequently, ownership of the facility eventually passed to the Mid Sussex District Council in 1974.

                    </p> 
                    Redevelopment of the site resulted in Bowls Club members being responsible for the green and the Council for the building. This arrangement reversed in 1976 when the pavilion was in danger of collapse. The Council maintained the green, fully renovating it in 1983, and the members restoring and enlarging the original pavilion. Sponsorship from the then President Edward Rowland enabled an additional structure to be built, housing changing rooms and toilets for 100 members.

                    <p>

                    </p> 

                    <p>
                    Concerns over security of tenure in the early 1990’s resulted in the Club negotiating and eventually purchasing the freehold of the green from the Council in 1994. Funds raised by members resulted in a new clubhouse being erected and opened by the Lord Lieutenant of West Sussex in June 1999.  

                    </p> 

                    <p>
                    A canopy, now makes life a little more comfortable for both members and visitors alike.

                    </p>
                </section>
                </div>
            </div>
           
        </div>    
    </Layout>
)

export default History;